import React from 'react'
import Footer from './Footer'
import Menu from './Menu'
import FormPopup from './FormPopup'
import PrivacyPopup from './PrivacyPopup'
import Annoucment from './Annoucment'

const Layout = ({ children, white }) => {
  return (
    <>
      <Menu white={white} className={white ? `is-white` : `` }/>
      <main>{children}</main>
      <Footer />
      <FormPopup />
      {/* <PrivacyPopup /> */}
      {/* <Annoucment /> */}
    </>
  )
}

export default Layout
